import React, { useState } from 'react';
import './CreatePost.css';
import QuillCo from './Quill/QuillCo';
import { Navigate } from 'react-router-dom';
import { SectionWrap } from '../../Components';

function CreatePost() {
    // const apiUrl = 'http://localhost/server/testServer/post.php';
    const apiUrl = 'https://www.albarede.com/server/post.php';

    const [title, setTitle] = useState('');
    const [summary, setSummary] = useState('');
    const [content, setContent] = useState('');
    const [files, setFiles] = useState('');
    const [author, setAuthor] = useState('');
    // إضافة حالة جديدة للوسوم
    const [tags, setTags] = useState(''); 
    const [createAt, setCreateAt] = useState(new Date());
    const [redirect, setRedirect] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false); // حالة جديدة لتتبع عملية النشر
    const [publishStatus, setPublishStatus] = useState(''); // لعرض حالة النشر (نجاح/فشل)

    const handleTextChange = (newText) => {
        setContent(newText);
    };

    async function createNewPost(ev) {
        ev.preventDefault();
        setIsPublishing(true); // بدء عملية النشر، إظهار شريط التقدم
        setPublishStatus('جارٍ نشر المقال وإرسال إشعارات لكل المشتركين...'); // تحديث حالة النشر

        // التحقق من الحقول الأساسية قبل الإرسال
        if (!title.trim() || !summary.trim() || !content.trim() || !author.trim()) {
            setPublishStatus('الرجاء ملء جميع الحقول المطلوبة.');
            setIsPublishing(false);
            return;
        }

        const data = new FormData();
        data.set('title', title);
        data.set('summary', summary);
        data.set('content', content);
        data.set('author', author);
        data.set('createAt', createAt.toISOString().slice(0, 19).replace('T', ' '));
        // إضافة الوسوم إلى بيانات النموذج
        data.set('tags', tags); 
        if (files && files[0]) {
            data.append('files', files[0]);
        }

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                body: data,
            });

            if (response.ok) {
                setPublishStatus('تم نشر المقال بنجاح!');
                setRedirect(true);
            } else {
                const errorText = await response.text();
                console.error('Error creating post:', errorText);
                setPublishStatus(`فشل النشر: ${errorText || 'خطأ غير معروف'}`);
            }
        } catch (error) {
            console.error('Network error creating post:', error);
            setPublishStatus('حدث خطأ أثناء الاتصال بالخادم. يرجى المحاولة لاحقاً.');
        } finally {
            setIsPublishing(false); // إنهاء عملية النشر، إخفاء شريط التقدم
        }
    }

    if (redirect) {
        return <Navigate to={'/articles'} />;
    }

    return (
        <div className="createPost">
            <SectionWrap>
                <form className="createFormPost" onSubmit={createNewPost}>
                    <h1>إضافة مقال جديد</h1>
                    <input
                        type="title"
                        placeholder="عنوان المقال"
                        value={title}
                        onChange={(ev) => setTitle(ev.target.value)}
                    />
                    <textarea
                        type="summary"
                        placeholder="موضوع المقال"
                        value={summary}
                        onChange={(ev) => setSummary(ev.target.value)}
                    />
                    <input
                        type="title"
                        placeholder="الكاتب"
                        value={author}
                        onChange={(ev) => setAuthor(ev.target.value)}
                    />
                    {/* حقل إدخال الوسوم الجديد */}
                    <input
                        type="text"
                        placeholder="الوسوم (افصل بينها بفاصلة)"
                        value={tags}
                        onChange={(ev) => setTags(ev.target.value)}
                    />
                    <label>اختر صورة للمقال</label>
                    <input
                        type="file"
                        name="files"
                        onChange={(ev) => setFiles(ev.target.files)}
                    />
                    <label>نص المقال</label>
                    <QuillCo onTextChange={handleTextChange} />
                    <button type="submit" className="postBtn" disabled={isPublishing} >
                        {isPublishing ? 'جارٍ النشر...' : 'نشر'}
                    </button>
                    {/* رسالة حالة النشر (تظهر فوق الشريط) */}
                    {publishStatus && (
                        <p
                            className={`eprov-allrt mt-4 font-semibold text-gray-800 ${ 
                                isPublishing 
                                    ? 'text-blue-700' 
                                    : publishStatus.includes('نجاح') 
                                        ? 'text-green-700' 
                                        : 'text-red-700' 
                            }`}
                        >
                            {publishStatus}
                        </p>
                    )}

                    {/* شريط التقدم (يظهر تحت الرسالة) */}
                    {isPublishing && (
                        <div className="progress mt-2"> 
                            <div 
                                className="progress-bar progress-bar-striped progress-bar-animated bg-info" 
                                role="progressbar" 
                                style={{ width: '100%' }} 
                                aria-valuenow="100" 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                            ></div>
                        </div>
                    )}
                </form>
            </SectionWrap>
        </div>
    );
}

export default CreatePost;